import React from "react";
import { createTheme } from "@material-ui/core";

const materialTheme = createTheme({
  overrides: {
    MuiInputLabel: {
      formControl: {
        fontSize: 14,
        transform: "none",
      },
      shrink: {
        transform: "none",
      },
    },
    MuiInput: {
      input: {
        fontSize: 14,
        fontFamily: "Poppins, sans-serif",
        fontWeight: 400,
        textAlign: "left",
        border: "1px solid #A5A5A5",
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: "5px !important",
        // backgroundColor: "rgb(0,0,0,0.1)",
        "&:active": {
          border: "1px solid #134869",
          backgroundColor: "#fdf7bd80",
        },
        "&:focus": {
          border: "1px solid #134869",
          backgroundColor: "#fdf7bd80",
        },
      },
      // formControl: {
      //   marginTop: "20px !important",
      // },
      underline: {
        "&&&:before": {
          borderBottom: "none",
        },
        "&&:after": {
          borderBottom: "none",
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "none !important",
        },
        "&:hover": {
          "&:not(.Mui-disabled)": {
            "&:before": {
              borderBottom: "none",
            },
          },
        },
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#134869",
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: "white",
      },
    },
    MuiTypography: {
      colorPrimary: {
        color: "black",
      },
    },
    MuiButton: {
      textPrimary: {
        color: "black",
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: "#134869",
        color: "white",
      },
    },
    MuiSelect: {
      select: {
        borderRadius: 25,
      },
    },
    MuiInputAdornment: {
      positionEnd: {
        marginLeft: -40,
      },
    },
    MuiIconButton: {
      root: {
        color: "#999999",
      },
    },
  },
});

export default materialTheme;
